import { useState } from 'react';
import { Badge, Box, Button, IconButton, Popover, Tooltip, Typography } from '@mui/material';
import { FilterList } from '@mui/icons-material';
import TagSelect from '../../components/TagSelect';

interface Props {
  tagIds: string[];
  onTags: (ids: string[]) => void;
}

/** The secondary filters; the entity filter sits on the toolbar (#375). The badge counts only what is in here. */
export default function FiltersButton({ tagIds, onTags }: Props) {
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
  const count = tagIds.length;

  return (
    <>
      <Tooltip title="Filters">
        <IconButton size="small" aria-label="Filters" color={count ? 'primary' : 'default'}
          onClick={(e) => setAnchorEl(e.currentTarget)}>
          <Badge badgeContent={count} color="primary"><FilterList fontSize="small" /></Badge>
        </IconButton>
      </Tooltip>
      <Popover
        open={!!anchorEl} anchorEl={anchorEl} onClose={() => setAnchorEl(null)}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        <Box sx={{ p: 2, width: { xs: '92vw', md: 480 }, maxWidth: '92vw', display: 'flex', flexDirection: 'column', gap: 1.5 }}>
          <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
            <Typography variant="subtitle2">Filters</Typography>
            {count > 0 && <Button size="small" onClick={() => onTags([])}>Clear all</Button>}
          </Box>
          <TagSelect value={tagIds} onChange={onTags} allowCreate={false} label="Tags" placeholder="All" sx={{ width: '100%' }} />
        </Box>
      </Popover>
    </>
  );
}
